import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from 'antd';
import React, { useState } from 'react';

import { EdutainmentDetailModal } from '@/components/UI/EdutainmentDetailModal';
import type { EdutainmentDetailValues } from '@/components/UI/EdutainmentDetailModal/types';

import { TEST_EDUTAINMENT_DETAIL } from '../../../EditEdutainmentModal/constants';
import { FixedSchedule } from '../../../FixedSchedule';
import { NonFixedSchedule } from '../../../NonFixedSchedule';
import type { EdutainmentApplication } from '../../types';
import {
  TEST_SCHEDULE_SETTING,
  WAITING_REVIEW_APPLICATIONS,
} from './constants';
import { getTableColumns } from './helpers';
import styles from './index.module.scss';
import type { ScheduleSetting } from './types';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { useForm } = Form;

const modalBodyStyles: React.CSSProperties = {
  maxHeight: '95vh',
  overflowY: 'auto',
};

export const WaitingReviewTable = () => {
  const [form] = useForm<ScheduleSetting>();

  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showRejectReasonEditor, setShowRejectReasonEditor] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [showScheduleSettingModal, setShowScheduleSettingModal] =
    useState(false);

  // TODO: 這邊如果之後改成用API拿資料後，記得刪除
  const [edutainmentReview, setEdutainmentReview] = useState<
    EdutainmentDetailValues | undefined
  >(undefined);
  const [scheduleSetting, setScheduleSetting] = useState<
    ScheduleSetting | undefined
  >(undefined);

  const onReviewButtonClick = (record: EdutainmentApplication) => {
    // TODO: 這邊應該是要打API去獲取可以顯示在detailModal中的資料內容，而不是使用table拿到的資料，又或是table資料如果跟表單資料是同一個的話，才可以這樣用
    // 不然應該都會需要轉換格式(無論是資料庫資料轉成table用的，或是轉成表單用的)
    console.log('review click-record:', record);

    // TODO: 到時候應該是從API獲取資料
    setEdutainmentReview({ ...TEST_EDUTAINMENT_DETAIL, refundPolicy: '' });

    setShowReviewModal(true);
  };

  const openRejectReasonEditor = () => {
    // TODO: 邏輯待寫
    console.log('openRejectReasonEditor rejectReason:', rejectReason);
    setShowRejectReasonEditor(true);
  };

  const closeRejectReasonEditor = () => {
    setRejectReason('');
    setShowRejectReasonEditor(false);
  };

  const rejectApplication = () => {
    if (!rejectReason) {
      message.error('請輸入退件原因');
      return;
    }
    // TODO: 邏輯待寫
    console.log('rejectApplication rejectReason:', rejectReason);
  };

  const approveApplication = () => {
    console.log('審核批准 approveApplication');

    // TODO: 邏輯待寫，不太確定這邊會是要打API拿資料，還是從上一層元件那接收資料，所以這邊先用state假資料來讓UI可以動
    setScheduleSetting(TEST_SCHEDULE_SETTING);

    setShowScheduleSettingModal(true);
  };

  const closeReviewModal = () => {
    setEdutainmentReview(undefined);
    setShowReviewModal(false);
  };

  const closeScheduleSettingModal = () => {
    setScheduleSetting(undefined);
    setShowScheduleSettingModal(false);
  };

  const handleScheduleSettingFinish = (formValues: ScheduleSetting) => {
    // TODO: 邏輯待寫
    console.log('formValues:', formValues);
  };

  const columns = getTableColumns(onReviewButtonClick);

  return (
    <>
      <Table
        bordered
        rowKey="_id"
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={WAITING_REVIEW_APPLICATIONS}
      />

      {edutainmentReview ? (
        <EdutainmentDetailModal
          open={showReviewModal}
          onCancel={closeReviewModal}
          edutainment={edutainmentReview}
          modalFooter={[
            <Button
              key="reject"
              type="primary"
              onClick={openRejectReasonEditor}
            >
              退件申請
            </Button>,
            <Button key="approve" onClick={approveApplication}>
              通過審核
            </Button>,
          ]}
        />
      ) : null}

      <Modal
        open={showRejectReasonEditor}
        onCancel={closeRejectReasonEditor}
        destroyOnClose
        centered
        maskClosable={false}
        onOk={rejectApplication}
      >
        <Space direction="vertical" className={styles['w-full']}>
          <Text type="secondary">退回申請</Text>
          <TextArea
            autoSize={{ minRows: 4, maxRows: 6 }}
            maxLength={100}
            showCount
            placeholder="例如：課程介紹不足......"
            value={rejectReason}
            onChange={(event) => setRejectReason(event.target.value)}
          />
        </Space>
      </Modal>

      {/* 
        TODO:
          裡面是一個Form，是關於時間設定的(固定時間 & 非固定時間)
          用戶已經填寫的也需要自動幫他們代入，資料應該是會在前一層modal時就拿到
      */}
      {scheduleSetting ? (
        <Modal
          open={showScheduleSettingModal}
          onCancel={closeScheduleSettingModal}
          destroyOnClose
          centered
          maskClosable={false}
          footer={null}
          width={1242}
          bodyStyle={modalBodyStyles}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={scheduleSetting}
            onFinish={handleScheduleSettingFinish}
          >
            <Space
              direction="vertical"
              size="middle"
              className={styles.modalBody}
            >
              <Title level={4}>育樂活動時間設定(不一定要進行更改)</Title>

              <FixedSchedule />
              <NonFixedSchedule />

              <Space className={styles.actionButtons}>
                <Button onClick={closeScheduleSettingModal}>取消</Button>
                <Button type="primary" htmlType="submit">
                  確定
                </Button>
              </Space>
            </Space>
          </Form>
        </Modal>
      ) : null}
    </>
  );
};
